import { mixpanel } from '@fiverr-private/obs';
import {
    MIXPANEL_EVENT_PROPERTIES,
    MIXPANEL_GENERIC_EVENTS,
    MIXPANEL_PAGE_NAMES,
} from '../../../../../shared/mixpanel';
import { getDataFromStores } from '../../../../../shared/utils';
import store from '../../store';

export const reportEditBriefClick = () => {
    mixpanel.track(MIXPANEL_GENERIC_EVENTS.PAGE_ACTION, {
        ...getDataFromStores(
            store.user,
            store.brief,
            store.briefSource,
            store.pagePath,
            store.statistics,
            store.referrer,
            store.fromBoost
        ),
        [MIXPANEL_EVENT_PROPERTIES.PAGE_NAME]: MIXPANEL_PAGE_NAMES.BUYER,
        [MIXPANEL_EVENT_PROPERTIES.ACTION]: 'Edit Brief Clicked',
    });
};
